module.exports = __webpack_public_path__ + "static/fluent-people-picker-be6855385da8536314a36c6b4a849271.png";